import React from "react";

function NewOrder() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#fe0"
        d="M416 0v64L208 79 0 64V0h160l48 15 48-15z"
        data-original="#ffee00"
      ></path>
      <path
        fill="#fc0"
        d="M416 0v64L208 79V15l48-15z"
        data-original="#ffcc00"
      ></path>
      <path fill="#fc0" d="M0 64h416v352H0z" data-original="#ffcc00"></path>
      <path
        fill="#ff9e00"
        d="M208 64h208v352H208z"
        data-original="#ff9e00"
      ></path>
      <path
        fill="#ff3d58"
        d="M256 0v149.25L208 128l-48 21.25V0z"
        data-original="#ff3d58"
      ></path>
      <path
        fill="#d20173"
        d="M256 0v149.25L208 128V0z"
        data-original="#d20173"
      ></path>
      <path
        fill="#fe0"
        d="M60.25 271.125h90.25v30H60.25zm0 60.25h60.125v30H60.25z"
        data-original="#ffee00"
      ></path>
      <circle
        cx="381.5"
        cy="381.5"
        r="130.5"
        fill="#97ff9e"
        data-original="#97cbff"
      ></circle>
      <path
        fill="#aaff7c"
        d="M512 381.5c0 72.07-58.43 130.5-130.5 130.5V251c72.07 0 130.5 58.43 130.5 130.5z"
        data-original="#7f7cff"
      ></path>
      <path
        fill="#f1f1f1"
        d="M451.6 366.5v30h-55.1v55.1h-30v-55.1h-55.1v-30h55.1v-55.1h30v55.1z"
        data-original="#f1f1f1"
      ></path>
      <path
        fill="#d6d6ea"
        d="M451.6 366.5v30h-55.1v55.1h-15V311.4h15v55.1z"
        data-original="#d6d6ea"
      ></path>
    </svg>
  );
}

export default NewOrder;
